import React from "react";
import { MdDelete } from "react-icons/md";

const OfferCard = ({ offers, setDeleteOfferModalOpen, setDeleteOfferId }) => {

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {offers.map((info, index) => (
        <div
          key={index}
          className="bg-white shadow-lg rounded-2xl overflow-hidden p-4"
        >
          <img
            src={info.image}
            alt={info.title}
            className="w-full h-40 object-cover rounded-lg"
            style={{ height: "10rem" }}
          />
          <div className="mt-4">
            <h3 className="text-lg font-semibold">
              {info.title}
            </h3>
            <div className="flex justify-between items-center mt-2">
              <p className="text-[#284184] font-bold text-lg">
                {info.percentage}% OFF
              </p>
              <button
                className="border p-2 rounded-md border-[#F04438]"
                onClick={() => {
                  setDeleteOfferId(info.id);
                  setDeleteOfferModalOpen(true);
                }}
              >
                <MdDelete className="text-[#F04438]" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OfferCard;
